<div class="warp-white">
    <div class="grid-header">
          <div class="select-cell">
            <input *ngIf="pendingApprovalTab$()" type="checkbox" class="select-checkbox" [checked]="isAllSelected" (change)="toggleSelectAll()" />
        </div>
        <div class="list-item chevron-cell pointer" [class.expanded]="isAllExpanded" (click)="toggleExpandAll()" [title]="'column.approvals.expandAll' | translate">
            <img class="chevron-icon" src="/assets/images/expand_more.svg" />
        </div>
        <div class="flex-2" translate>column.approvals.name</div>
        <div class="flex-1" translate>column.questionnaireNumber</div>
        <div
      class="flex-1 pointer"
      role="button"
      tabindex="0"
      (click)="requestSort(ApprovalSortBy.SentDate)"
      (keydown.enter)="requestSort(ApprovalSortBy.SentDate)"
      (keydown.space)="handleSpaceKey($event, ApprovalSortBy.SentDate)"
    >
      <span translate>column.approvals.sentDate</span>

      <span
        *ngIf="sortBy === ApprovalSortBy.SentDate"
        class="sort-arrow"
      >
        {{
          sortDirection === SortDirection.Asc
            ? '▲'
            : '▼'
        }}
      </span>
    </div>

    <div
      class="flex-1_2 pointer"
      role="button"
      tabindex="0"
      (click)="requestSort(ApprovalSortBy.SenderName)"
      (keydown.enter)="requestSort(ApprovalSortBy.SenderName)"
      (keydown.space)="handleSpaceKey($event, ApprovalSortBy.SenderName)"
    >
      <span translate>column.approvals.senderName</span>

      <span
        *ngIf="sortBy === ApprovalSortBy.SenderName"
        class="sort-arrow"
      >
        {{
          sortDirection === SortDirection.Asc
            ? '▲'
            : '▼'
        }}
      </span>
    </div>

    <div
      *ngIf="downloadRecordsTab$()"
      class="flex-1_2 pointer"
      role="button"
      tabindex="0"
      (click)="requestSort(ApprovalSortBy.ApproverName)"
      (keydown.enter)="requestSort(ApprovalSortBy.ApproverName)"
      (keydown.space)="handleSpaceKey($event, ApprovalSortBy.ApproverName)"
    >
      <span translate>column.approvals.approverName</span>

      <span
        *ngIf="sortBy === ApprovalSortBy.ApproverName"
        class="sort-arrow"
      >
        {{
          sortDirection === SortDirection.Asc
            ? '▲'
            : '▼'
        }}
      </span>
    </div>

    <div
      *ngIf="afterApprovalTab$()"
      class="flex-2"
      translate
    >
      column.approvals.status
    </div>

    <div
      *ngIf="downloadRecordsTab$() || afterApprovalTab$()"
      class="flex-1 pointer"
      role="button"
      tabindex="0"
      (click)="requestSort(ApprovalSortBy.ApprovalDate)"
      (keydown.enter)="requestSort(ApprovalSortBy.ApprovalDate)"
      (keydown.space)="handleSpaceKey($event, ApprovalSortBy.ApprovalDate)"
    >
      <span translate>column.approvals.approvalDate</span>

      <span
        *ngIf="sortBy === ApprovalSortBy.ApprovalDate"
        class="sort-arrow"
      >
        {{
          sortDirection === SortDirection.Asc
            ? '▲'
            : '▼'
        }}
      </span>
    </div>

    <div *ngIf="afterApprovalTab$()" class="flex-1" translate>
      column.approvals.payrollMonth
    </div>

    <div
      class="flex-1_8 pointer"
      role="button"
      tabindex="0"
      (click)="requestSort(ApprovalSortBy.ExtraDetails)"
      (keydown.enter)="requestSort(ApprovalSortBy.ExtraDetails)"
      (keydown.space)="handleSpaceKey($event, ApprovalSortBy.ExtraDetails)"
    >
      <span translate>column.extraDetails</span>

      <span
        *ngIf="sortBy === ApprovalSortBy.ExtraDetails"
        class="sort-arrow"
      >
        {{
          sortDirection === SortDirection.Asc
            ? '▲'
            : '▼'
        }}
      </span>
    </div>

    <div class="flex-half last"></div>
  </div>
</div>